const formContainer = document.getElementById("fixed-form");
const header = document.querySelector(".header");
const formWrapper = document.getElementById("formWrapper");
const floatingBtn = document.getElementById("floatingFormBtn");
const closeBtn = document.getElementById("closeFormBtn");
const overlay = document.getElementById("formOverlay");
const footer = document.querySelector(".swiper-testimonials");
let isFormOpen = false;

function setupDesktopBehavior() {
  const formOffsetTop = formContainer.offsetTop;
  const formHeight = formContainer.offsetHeight;
  const headerHeight = header.offsetHeight;
  const containerRect = formContainer.getBoundingClientRect();
  const originalRight = window.innerWidth - containerRect.right;
  let isFixed = false;

  window.addEventListener("scroll", function () {
    const footerRect = footer.getBoundingClientRect();
    const formBottomPosition = window.scrollY + headerHeight + formHeight;
    const footerTopPosition = footer.offsetTop;

    const willOverlapFooter = formBottomPosition > footerTopPosition;

    if (
      window.scrollY >= formOffsetTop - headerHeight &&
      !isFixed &&
      !willOverlapFooter
    ) {
      formContainer.style.position = "fixed";
      formContainer.style.top = `${headerHeight}px`;
      formContainer.style.right = `${originalRight}px`;
      formContainer.style.width = `${formContainer.offsetWidth}px`;
      formContainer.style.zIndex = "1000";
      isFixed = true;

      const nextElement = formContainer.nextElementSibling;
      if (nextElement) nextElement.style.marginTop = `${formHeight}px`;
    } else if (
      (window.scrollY < formOffsetTop - headerHeight || willOverlapFooter) &&
      isFixed
    ) {
      formContainer.style.position = "";
      formContainer.style.top = "";
      formContainer.style.right = "";
      formContainer.style.width = "";
      formContainer.style.zIndex = "";
      isFixed = false;

      const nextElement = formContainer.nextElementSibling;
      if (nextElement) nextElement.style.marginTop = "";
    }
  });

  window.addEventListener("resize", function () {
    if (isFixed) {
      const newRight =
        window.innerWidth - formContainer.getBoundingClientRect().right;
      formContainer.style.right = `${newRight}px`;
    }
  });
}

function setupMobileBehavior() {
  function toggleForm(show) {
    if (show) {
      formWrapper.classList.add("active");
      overlay.classList.add("active");
      document.body.style.overflow = "hidden";
      isFormOpen = true;
    } else {
      formWrapper.classList.remove("active");
      overlay.classList.remove("active");
      document.body.style.overflow = "";
      isFormOpen = false;
    }
  }

  floatingBtn.addEventListener("click", () => toggleForm(!isFormOpen));
  closeBtn.addEventListener("click", () => toggleForm(false));
  overlay.addEventListener("click", () => toggleForm(false));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isFormOpen) toggleForm(false);
  });
}

function checkScreenSize() {
  if (window.innerWidth >= 1040) {
    floatingBtn.style.display = "none";
    overlay.classList.remove("active");
    formWrapper.classList.remove("active");
    document.body.style.overflow = "";
    setupDesktopBehavior();
  } else {
    floatingBtn.style.display = "flex";
    setupMobileBehavior();
  }
}

checkScreenSize();
window.addEventListener("resize", checkScreenSize);
